import { render } from "./ClinicProviderInfo.vue?vue&type=template&id=a86a51a0&scoped=true&ts=true"
import script from "./ClinicProviderInfo.vue?vue&type=script&lang=ts"
export * from "./ClinicProviderInfo.vue?vue&type=script&lang=ts"

import "./ClinicProviderInfo.vue?vue&type=style&index=0&id=a86a51a0&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86a51a0"]])

export default __exports__